import { createSlice } from "@reduxjs/toolkit";

/**
 * Shrunk for B1. The Gen 2 payload has no campaign_id / target_type /
 * target_ids, and the merged dialog holds its optional pickers in local state
 * (they are per-dialog-session, never shared), so only the fixture selection
 * — which FixtureBrowser sets from a sibling component — still needs the store.
 */
const initialState = {
    selectedFixture: null,  // normalised fixture object from API-Football
    step:            1,     // 1 = pick fixture, 2 = configure
};

const matchSchedulerSlice = createSlice({
    name: "matchScheduler",
    initialState,
    reducers: {
        setSelectedFixture: (state, { payload }) => { state.selectedFixture = payload; },
        setStep:            (state, { payload }) => { state.step            = payload; },
        resetWizard: (state) => {
            state.selectedFixture = null;
            state.step            = 1;
        },
    },
});

export const { setSelectedFixture, setStep, resetWizard } = matchSchedulerSlice.actions;

export default matchSchedulerSlice.reducer;
